/**
 * A etiqueta colorida de uma categoria.
 *
 * As cores das categorias existem no banco desde a Fase 2 — cada uma nasce
 * com um `colorToken` —, mas nunca chegavam a tela: a folha de estilo so
 * conhecia o acento e o par entrada/saida, entao tudo saia cinza. Este
 * componente e o outro lado dessa ponte.
 *
 * Cor sozinha nao identifica nada para quem nao distingue cores, e "verde" e
 * "teal" ficam iguais em muitas telas. Por isso a etiqueta sempre mostra o
 * NOME junto do ponto: a cor acelera o reconhecimento de quem ja sabe, o
 * texto garante que ninguem fique sem a informacao.
 */

const TOKENS = new Set(['ink', 'amber', 'green', 'red', 'blue', 'violet', 'teal', 'rose']);

/** A variavel CSS da cor, com queda para o neutro se o token for desconhecido. */
export function categoryColor(token: string | null | undefined): string {
  return `var(--cat-${token && TOKENS.has(token) ? token : 'ink'})`;
}

export function categoryColorSoft(token: string | null | undefined): string {
  return `var(--cat-${token && TOKENS.has(token) ? token : 'ink'}-soft)`;
}

export function CategoryTag({
  name,
  colorToken,
  title,
}: {
  name: string | null;
  colorToken: string | null;
  title?: string;
}) {
  if (!name) return <span className="muted">Sem categoria</span>;

  return (
    <span
      className="cat-tag"
      title={title ?? name}
      style={{ background: categoryColorSoft(colorToken), color: categoryColor(colorToken) }}
    >
      <span className="cat-dot" style={{ background: categoryColor(colorToken) }} aria-hidden />
      {name}
    </span>
  );
}

/** O ponto sozinho, para tabelas onde o nome ja aparece na coluna ao lado. */
export function CategoryDot({ colorToken }: { colorToken: string | null }) {
  return <span className="cat-dot" style={{ background: categoryColor(colorToken) }} aria-hidden />;
}
